module.exports = __webpack_public_path__ + "static/media/overview.c4106374.svg";